<script setup lang="ts">
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useLearningPathAttendeeStore } from "~/store/learning-path/learning-path-attendee.store";
import AttendeeJourney from "./AttendeeJourney.vue";
import UserIcon from "~/components/Header/UserIcon.vue";

const router = useRouter();
const route = useRoute();

const learningPathAttendeeStore = useLearningPathAttendeeStore();
const { learningPathAttendee } = storeToRefs(learningPathAttendeeStore);

function navigateToParticipants() {
  const { attendee_id, ...restQuery } = route.query;
  router.push({
    query: {
      ...restQuery,
    },
  });

  learningPathAttendeeStore.handleLearningPathAttendee(false);
  learningPathAttendeeStore.setLearningPathAttendee(null);
}

onMounted(async () => {
  if (route.query.attendee_id) {
    await learningPathAttendeeStore.loadAttendeeProfile(
      route.query.attendee_id as string,
      route.query.learning_path_id as string,
    );
  }
});
</script>

<template>
  <div class="flex flex-col gap-6">
    <button
      class="flex items-center button_secondary_default whitespace-nowrap body_regular"
      @click="navigateToParticipants()"
    >
      <SvgIcon name="arrow_left" class="w-6 h-6" />
      <span>Retour participants</span>
    </button>
    <div v-if="route.query.attendee_id" class="flex items-center">
      <div class="display-profile">
        <div class="flex items-center gap-2">
          <UserIcon :initials="learningPathAttendee?.displayValue?.avatar"> </UserIcon>
        </div>
        <span>{{ learningPathAttendee?.displayValue?.value ?? "-" }}</span>
      </div>
    </div>
  </div>
  <AttendeeJourney
    v-if="learningPathAttendee?.attendeeId && learningPathAttendee?.learningPathId"
    :attendee-id="learningPathAttendee?.attendeeId"
    :learning-path-id="learningPathAttendee?.learningPathId"
  />
</template>

<style lang="scss" scoped>
@use "assets/scss/texts";

.display-profile {
  @apply flex gap-2 items-center transition-all duration-200 text-secondary-color pt-[1px];
}
</style>
